<template>
  <div class="block">
    <v-switch v-model="check" class="noneDetails" color="#277faf" />
    <EmployeeIcon :class="{ active: check }" />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

import EmployeeIcon from 'components/icons/employees/Employee'

export default {
  name: 'EmployeeCreateDelete',
  data() {
    return {
      check: false,
    }
  },
  components: { EmployeeIcon },
  created() {
    this.check = this.commonUserDataEmployee
  },
  watch: {
    commonUserDataEmployee() {
      this.check = this.commonUserDataEmployee
    },
    check() {
      this.setCommonUserDataEmployee(this.check)
    },
  },

  methods: {
    ...mapMutations('commonUser', ['setCommonUserDataEmployee']),
  },
  computed: {
    ...mapGetters('commonUser', ['commonUserDataEmployee']),
  },
}
</script>

<style lang="scss" scoped>
.block:deep() {
  padding: 20px 0;
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 20px;
  align-items: center;
  justify-content: start;
  .v-input--selection-controls {
    margin: 0;
    padding: 0;
    .v-messages {
      display: none;
    }
  }
  svg {
    path {
      fill: #cccccc;
      transition: 0.3s;
    }
    &.active {
      path {
        fill: #f2a127;
      }
    }
  }
  @media screen and (max-width: 600px) {
    // grid-template-columns: 1fr;
    padding: 5px 10px;
  }
}
</style>
